import Page from '../../classes/Page'
import { app } from '../../utils/store'
import { media } from '../../utils/media'

import each from 'lodash/each'

import gsap from 'gsap'

export default class About extends Page{
    constructor(){
        super({
            id : 'about',
            element: '[data-app-page]',
            elements: { 
                timeline: 'section.timeline',
            },
            // scroller: app.wrapper,
        })


        this.milestones = {
            btnNext: document.getElementById('next-btn-timeline'),
            btnPrev: document.getElementById('prev-btn-timeline'),
        }
        // scrolleft-current - (width-next-single-item)
        // width-container - (width-next-single-item)
    }
    
    create() {
        super.create()
        
        if(this.elements.timeline){ this.createObserver()}

        this.scroll = {
            current: 0,
            last: 0,
        }
        this.createTimeline()
    }

    createObserver() {
        this.observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (media('<iPadLandscape')) {
                    if (entry.isIntersecting) { // "Scrolling UP" this.scroll.currentY < this.scroll.previousY &&
                        this.milestones.btnNext.classList.add('active');
                        this.milestones.btnPrev.classList.add('active');
                    } else {
                        this.milestones.btnNext.classList.remove('active');
                        this.milestones.btnPrev.classList.remove('active');
                    }
                }
            })
        }, {
            rootMargin: `-80%`,
        })

        this.observer.observe(this.elements.timeline)
    }
    
    createTimeline = () => {
        this.timeline = gsap.timeline({ paused: true })


        let container = this.elements.timeline.querySelector('.content')
        this.scroll.current = container.scrollLeft
        let lastScroll = 0
        let maxScrollLeft = container.scrollWidth - container.clientWidth;


        this.milestones.btnNext.onclick = (event) => {
            let slides = container.children
            let offViewport = new Array()

            each(slides, (slide) => {
                if(slide.offsetLeft > (container.clientWidth - (window.innerWidth * .25))){
                    offViewport.push(slide)
                }
            })
            lastScroll = container.scrollLeft
            if (media('>=iPadLandscape')) {
                console.log('prova desktop')
                gsap.to(container, {
                    scrollLeft: (lastScroll + (window.innerWidth / 4)),
                    ease: 'linear',
                }) 
            } else {
                console.log('prova mobile')
                gsap.to(container, {
                    scrollLeft: (lastScroll + (window.innerWidth / 3 * 2)),
                    ease: 'linear',
                }) 
            }
            // let currentScroll = container.scrollLeft += offViewport[0].clientWidth
            
            this.milestones.btnPrev.style.setProperty('display', 'block');
            if (lastScroll == maxScrollLeft) {
                this.milestones.btnNext.style.setProperty('display', 'none');
            }
        }


        this.milestones.btnPrev.onclick = (event) => {
            let offViewport = new Array()
            let slides = container.children

            each(slides, (slide) => {
                if(slide.offsetLeft > (container.clientWidth - (window.innerWidth * .25))){
                    offViewport.push(slide)
                }
            })
            lastScroll = container.scrollLeft
            if (media('>=iPadLandscape')) {
                gsap.to(container, {
                    scrollLeft: (lastScroll - (window.innerWidth / 4)),
                    ease: 'linear',
                }) 
            } else {
                gsap.to(container, {
                    scrollLeft: (lastScroll - (window.innerWidth / 3 * 2)),
                    ease: 'linear',
                }) 
            }
            // container.scrollLeft -= offViewport[0].clientWidth 
            if (container.scrollLeft == 0) {
                this.milestones.btnPrev.style.setProperty('display', 'none'); 
                lastScroll = container.scrollLeft
            }

            if (lastScroll < maxScrollLeft) {
                this.milestones.btnNext.style.setProperty('display', 'block');
            }
        }

    }
    
    addEventListeners() {
        
    }

    destroy(){ 
        super.destroy()
    }
}